import type { ReferralSpecialtyCode } from '../referral/referralTypes'

export interface NuccClassification {
  code: ReferralSpecialtyCode
  label: string
}

export const NUCC_SYSTEM = 'http://nucc.org/provider-taxonomy'

export const NUCC_CLASSIFICATIONS: NuccClassification[] = [
  { code: '207K00000X', label: 'Allergy & Immunology' },
  { code: '207RC0000X', label: 'Cardiology' },
  { code: '207N00000X', label: 'Dermatology' },
  { code: '207RE0101X', label: 'Endocrinology' },
  { code: '207Y00000X', label: 'ENT / Otolaryngology' },
  { code: '207Q00000X', label: 'Family Medicine' },
  { code: '207RG0100X', label: 'Gastroenterology' },
  { code: '208600000X', label: 'General Surgery' },
  { code: '207QG0300X', label: 'Geriatrics' },
  { code: '207RH0000X', label: 'Hematology' },
  { code: '207RX0202X', label: 'Hematology / Oncology' },
  { code: '207RI0200X', label: 'Infectious Disease' },
  { code: '207R00000X', label: 'Internal Medicine' },
  { code: '207RN0300X', label: 'Nephrology' },
  { code: '2084N0400X', label: 'Neurology' },
  { code: '207V00000X', label: 'Obstetrics & Gynecology' },
  { code: '207W00000X', label: 'Ophthalmology' },
  { code: '207X00000X', label: 'Orthopedic Surgery' },
  { code: '208VP0000X', label: 'Pain Medicine' },
  { code: '208000000X', label: 'Pediatrics' },
  { code: '208100000X', label: 'Physical Medicine & Rehabilitation' },
  { code: '208200000X', label: 'Plastic Surgery' },
  { code: '213E00000X', label: 'Podiatry' },
  { code: '2084P0800X', label: 'Psychiatry' },
  { code: '207RP1001X', label: 'Pulmonology' },
  { code: '2085R0001X', label: 'Radiation Oncology' },
  { code: '207RR0500X', label: 'Rheumatology' },
  { code: '207RS0012X', label: 'Sleep Medicine' },
  { code: '207RS0010X', label: 'Sports Medicine' },
  { code: '208800000X', label: 'Urology' },
  { code: '2086S0129X', label: 'Vascular Surgery' },
]

// Widened to `string`: `code` here is a value already stored on a FHIR resource, not
// necessarily one of the known literals, so the lookup itself must accept any string.
const byCode = new Map<string, string>(NUCC_CLASSIFICATIONS.map((c) => [c.code, c.label]))

export function getSpecialtyLabel(code: string | undefined): string {
  if (!code) return ''
  return byCode.get(code) ?? code
}
